<template>
  <div>
    <div v-if="loading">
      <div class="loader-detail"></div>
    </div>
      <!-- <div v-if="loading">Loading...</div> -->
    <div class="flex-column" v-else>
      <div class="admin-block-wrap">
        <div class="admin-block">
          <div class="admin-block-title">MRR</div>
          <div class="admin-block-content">{{ data.contract.mrr }}</div>
          <div class="admin-block-sub-content">
            <div>ARR: {{ data.contract.arr }}</div>
          </div>
          <div class="admin-block-divider"></div>
          <div class="admin-block-bottom-content">
            <div>New MRR(今月)</div>
            <div>{{ data.contract.new_mrr_this_month }}</div>
          </div>
          <div class="admin-block-divider"></div>
          <div class="admin-block-bottom-content">
            <div>New MRR(先月)</div>
            <div>{{ data.contract.new_mrr_1month }}</div>
          </div>
        </div>

        <div class="admin-block">
          <div class="admin-block-title">契約数</div>
          <div class="admin-block-content">{{ data.client_count.active_client }}</div>
          <div class="admin-block-sub-content">
            <div><font-awesome-icon :icon="['fas', 'rocket-launch']" style="margin-right:5px" />PRO: {{ data.client_count.pro_client }}</div>
            <div><font-awesome-icon :icon="['fas', 'fire-alt']" style="margin-right:5px" />MANAGER: {{ data.client_count.manager_client }}</div>
          </div>
          <div class="admin-block-divider"></div>
          <div class="admin-block-bottom-content">
            <div>新規契約(今月)</div>
            <div>{{ data.client_count.new_contract_this_month }}</div>
          </div>
          <div class="admin-block-divider"></div>
          <div class="admin-block-bottom-content">
            <div>新規契約(先月)</div>
            <div>{{ data.client_count.new_contract_1month }}</div>
          </div>
        </div>

        <div class="admin-block">
          <div class="admin-block-title">ARPU</div>
          <div class="admin-block-content">{{ data.contract.arpu }}</div>
          <div class="admin-block-sub-content">
            <div>Min: {{ data.contract.contract_price_min }}</div>
            <div>Max: {{ data.contract.contract_price_max }}</div>
          </div>
          <div class="admin-block-divider"></div>
          <div class="admin-block-bottom-content">
            <div>ARPU(今月)</div>
            <div>{{ data.contract.arpu_this_month }}</div>
          </div>
          <div class="admin-block-divider"></div>
          <div class="admin-block-bottom-content">
            <div>ARPU(先月)</div>
            <div>{{ data.contract.arpu_1month }}</div>
          </div>
        </div>

        <div class="admin-block">
          <div class="admin-block-title">平均契約期間</div>
          <div class="admin-block-content">{{ data.contract.average_contract_period }}</div>
          <div class="admin-block-sub-content">
            <div>Min: {{ data.contract.min_contract_period }}</div>
            <div>Max: {{ data.contract.max_contract_period }}</div>
          </div>
          <div class="admin-block-divider"></div>
          <div class="admin-block-bottom-content">
            <div>平均契約期間(今月)</div>
            <div>{{ data.contract.average_contract_period_this_month }}</div>
          </div>
          <div class="admin-block-divider"></div>
          <div class="admin-block-bottom-content">
            <div>平均契約期間(先月)</div>
            <div>{{ data.contract.average_contract_period_1month }}</div>
          </div>
        </div>

        <div class="admin-block">
          <div class="admin-block-title">インフルエンサー数</div>
          <div class="admin-block-content">{{ data.influencer_num.influencer_num }}</div>
          <div class="admin-block-sub-content">
            <div><font-awesome-icon :icon="['fab', 'instagram']" style="margin-right: 3px;" />{{ data.influencer_num.instagram }}</div>
            <div><font-awesome-icon :icon="['fab', 'youtube']" style="margin-right: 3px;" />{{ data.influencer_num.youtube }}</div>
            <div><font-awesome-icon :icon="['fab', 'tiktok']" style="margin-right: 3px;" />{{ data.influencer_num.tiktok }}</div>
          </div>
          <div class="admin-block-divider"></div>
          <div class="admin-block-bottom-content">
            <div>増加数(今月)</div>
            <div>{{ data.influencer_num.influencer_num_this_month }}</div>
          </div>
          <div class="admin-block-divider"></div>
          <div class="admin-block-bottom-content">
            <div>増加数(先月)</div>
            <div>{{ data.influencer_num.influencer_num_1m }}</div>
          </div>
        </div>
      </div>

      <div class="admin-block-wrap">
        <div class="admin-block">
          <div class="admin-block-title">顧客満足度</div>
          <div class="admin-block-content">{{ data.nps.nps_score }}</div>
          <div class="admin-block-sub-content">
            <div>件数: {{ data.nps.nps_count }}</div>
          </div>
          <div class="admin-block-divider"></div>
          <div class="admin-nps-wrap">
            <div v-for="nps in nps_list" :key="nps" class="admin-nps">
              <div class="admin-nps-score">{{ nps.score }}</div>
              <div class="admin-nps-bar" :style="'width:' + nps.percent + '%'"></div>
              <div>{{ nps.count }}({{ nps.percent }}%)</div>
            </div>
          </div>
        </div>
        <div class="admin-block">
          <div class="admin-block-title">カスタマーチャーンレート(年次)</div>
          <div class="admin-block-content">{{ data.churn.customer_churn_rate }}%</div>
          <div class="admin-block-sub-content">
            <div><font-awesome-icon :icon="['fas', 'rocket-launch']" style="margin-right:5px" />PRO: {{ data.client_count.pro_client }}</div>
          </div>
          <div class="admin-block-divider"></div>
          <div class="admin-block-bottom-content">
            <div>解約数(直近1年)</div>
            <div>{{ data.churn.cancel_count }}</div>
          </div>
          <div class="admin-block-divider"></div>
          <div class="admin-block-bottom-content">
            <div>契約数(直近1年)</div>
            <div>{{ data.churn.purchase_count }}</div>
          </div>
        </div>

        <div class="admin-block">
          <div class="admin-block-title">レベニューチャーンレート(年次)</div>
          <div class="admin-block-content">{{ data.churn.revenue_churn_rate }}%</div>
          <div class="admin-block-sub-content">
            <div><font-awesome-icon :icon="['fas', 'rocket-launch']" style="margin-right:5px" />PRO: {{ data.client_count.pro_client }}</div>
          </div>
          <div class="admin-block-divider"></div>
          <div class="admin-block-bottom-content">
            <div>解約数(直近1年)</div>
            <div>{{ data.churn.cancel_price }}</div>
          </div>
          <div class="admin-block-divider"></div>
          <div class="admin-block-bottom-content">
            <div>契約数(直近1年)</div>
            <div>{{ data.churn.purchase_price }}</div>
          </div>
        </div>

        <div class="admin-block">
          <div class="admin-block-title">アクティビティ(PV数)</div>
          <div class="admin-block-content">{{ data.activity.pv_1month }}</div>
          <div class="admin-block-sub-content">
            <div>最大: {{ data.activity.pv_1month_max }}</div>
            <div>最小: {{ data.activity.pv_1month_min }}</div>
          </div>
          <div class="admin-block-divider"></div>
          <div class="admin-block-bottom-content">
            <div>60日前~30日前</div>
            <div>{{ data.activity.pv_2month }}</div>
          </div>
          <div class="admin-block-divider"></div>
          <div class="admin-block-bottom-content">
            <div>90日前~60日前</div>
            <div>{{ data.activity.pv_3month }}</div>
          </div>
        </div>

        <div class="admin-block">
          <div class="admin-block-title">アクティビティ(UU数)</div>
          <div class="admin-block-content">{{ data.activity.uu_1month }}</div>
          <div class="admin-block-sub-content">
            <!-- <div>最大: {{ data.activity.pv_1month_max }}</div>
          <div>最小: {{ data.activity.pv_1month_min }}</div> -->
          </div>
          <div class="admin-block-divider"></div>
          <div class="admin-block-bottom-content">
            <div>60日前~30日前</div>
            <div>{{ data.activity.uu_2month }}</div>
          </div>
          <div class="admin-block-divider"></div>
          <div class="admin-block-bottom-content">
            <div>90日前~60日前</div>
            <div>{{ data.activity.uu_3month }}</div>
          </div>
        </div>

        <div class="admin-block">
          <div v-for="client in data.access_list" :key="client.client_name">{{ client.client_name }} - {{ client.access_count }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const dashboardAPI = root + "/api/admin/admin_dashboard";

export default {
  name: "adminDashboard",
  props: [],
  data() {
    return {
      data: [],
      loading: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    nps_list() {
      return this.data.nps.nps_list.slice().reverse();
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      var params = new URLSearchParams();
      params.append("token", this.token);
      this.axios
        .post(dashboardAPI, params)
        .then((response) => {
          this.data = response.data.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>
